import React from 'react'
import PropTypes from 'prop-types'
import { PropTypes as MobxPropTypes } from 'mobx-react'
import cn from 'classnames'
import { compose, defaultProps, withHandlers } from 'recompose'
import { removeFromArray } from '../../../../lib/utils/collection'

const enhance = compose(
  defaultProps({
    identity: v => v,
    isDisabled: () => false,
    label: v => v
  }),
  withHandlers({
    onCheckboxChange: ({ identity, isDisabled, onChange, value = [] }) => option => e => {
      if (isDisabled(option)) {
        e.preventDefault()
        return
      }

      const optionId = identity(option)
      onChange(
        e.target.checked
          ? [...value, optionId]
          : removeFromArray(value, optionId)
      )
    }
  })
)

const CheckboxGroup = ({ className, identity, isDisabled, label, onCheckboxChange, options, value = [] }) => {
  return (
    <div className={cn('CheckboxGroup', className)}>
      {options.map(option => {
        const optionId = identity(option)
        const disabled = isDisabled(option)
        const isChecked = value.includes(optionId)

      return (
        <div key={optionId} className='CheckboxGroup-checkbox'>
          <div className={cn('Checkbox', { isDisabled: disabled })}>
            <label
              className='Checkbox-label'
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()

                if (!disabled && e.target.tagName !== 'INPUT' && e.target.type !== 'checkbox') {
                  const checkbox = e.currentTarget.querySelector('input[type="checkbox"]')
                  if (checkbox && !checkbox.disabled) {
                    const currentlyChecked = value.includes(optionId)
                    const newChecked = !currentlyChecked

                    const syntheticEvent = {
                      target: {
                        ...checkbox,
                        checked: newChecked
                      },
                      currentTarget: checkbox,
                      preventDefault: () => {},
                      stopPropagation: () => {}
                    }

                    onCheckboxChange(option)(syntheticEvent)
                  }
                }
              }}
            >
              <input
                className='Checkbox-input'
                type='checkbox'
                checked={isChecked}
                onChange={(e) => {
                  e.stopPropagation()
                  onCheckboxChange(option)(e)
                }}
                onClick={(e) => {
                  e.stopPropagation()
                }}
                disabled={disabled}
              />
              <span className='Checkbox-icon' />
              {label(option)}
            </label>
          </div>
        </div>
      )
    })}
  </div>
  )
}

CheckboxGroup.propTypes = {
  className: PropTypes.string,
  identity: PropTypes.func,
  isDisabled: PropTypes.func,
  label: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  value: MobxPropTypes.arrayOrObservableArray
}

export default enhance(CheckboxGroup)
